import { routerStyxie } from '@/router/styxieBridge'
import { useMlapProjectStore } from '@/stores/mlapProject'
import { useMlapProjectPagesStore } from '@/stores/mlapProjectPages'

// Client-side routed under the project layout (see router/routes/mlap.js).
Styxie.Initializers.MlapProjectsMap = routerStyxie({
  actions: ['show'],
  hydrate: (props, pinia) => {
    useMlapProjectStore(pinia).hydrate(props.project)
    useMlapProjectPagesStore(pinia).hydrateMeta(props)
  }
})
